import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface DiffMarkerProps {
  previousValue: string | number
  currentValue: string | number
  className?: string
}

export function DiffMarker({
  previousValue,
  currentValue,
  className,
}: DiffMarkerProps) {
  const prev = String(previousValue)
  const curr = String(currentValue)
  return (
    <span
      data-testid="diff-marker"
      data-prev={prev}
      data-current={curr}
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-slate-300 bg-slate-100 px-1.5 py-0.5 text-[10px] text-slate-700 dark:border-slate-500/40 dark:bg-slate-500/10 dark:text-slate-300',
        className,
      )}
    >
      <span className="text-slate-500 dark:text-slate-400">prev:</span>
      <span className="font-medium tabular-nums">{prev}</span>
      <ArrowRight size={10} />
      <span className="font-medium tabular-nums">{curr}</span>
    </span>
  )
}
